import { useEffect, useState } from 'react';
import HeroSection from './components/HeroSection';
import VideoEmbed from './components/VideoEmbed';
import AboutConference from './components/AboutConference';
import AboutSHAY from './components/AboutSHAY';
import ConferenceDates from './components/ConferenceDates';
import WhatToExpect from './components/WhatToExpect';
import MinistryTeam from './components/MinistryTeam';
import StandStill from './components/StandStill';
import MediaHighlights from './components/MediaHighlights';
import StayConnected from './components/StayConnected';
import FooterSection from './components/FooterSection';
import SEOSchema from './components/SEOSchema';

const HomePage = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <main
      className="min-h-screen"
      style={{ background: '#080808', fontFamily: 'Inter, sans-serif' }}
    >
      <SEOSchema />
      <HeroSection />
      <VideoEmbed />
      <AboutConference />
      <AboutSHAY />
      <ConferenceDates />
      <WhatToExpect />
      <MinistryTeam />
      <StandStill />
      <MediaHighlights />
      <StayConnected />
      <FooterSection />

      {/* Scroll to top button */}
      <button
        onClick={scrollToTop}
        aria-label="Scroll to top"
        className="fixed bottom-8 right-5 z-50 cursor-pointer transition-all duration-300 flex items-center justify-center"
        style={{
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #F5D060, #D4A842)',
          boxShadow: '0 0 20px rgba(212,168,66,0.6)',
          border: 'none',
          opacity: showTop ? 1 : 0,
          transform: showTop ? 'scale(1) translateY(0)' : 'scale(0.7) translateY(16px)',
          pointerEvents: showTop ? 'auto' : 'none',
        }}
      >
        <span style={{ fontSize: '22px', color: '#000', fontWeight: 900, lineHeight: 1, marginTop: '-2px' }}>↑</span>
      </button>
    </main>
  );
};

export default HomePage;
